var Product = (function () {
    return {
        updateProgressBar: function (product, variantCount) {
            let precent = null;
            if (product) {
                //let coountAllProduct = product.quantity.reduce((sum, currentValue) => sum + +currentValue.quantity, 0);
                let coountmax = $('.count-product-progress').attr('data-instock_max');

                precent = (variantCount * 100) / coountmax + '%';
                if (variantCount > coountmax) {
                    $('.count-product-progress_wrapp').slideUp(300);
                } else {
                    $('.count-product-progress_wrapp').slideDown();
                }
            } else {
                precent = 0;
            }
            $('.count-product-progress__bar').width(precent);
        },

        updatePrice: function (product, variantId, selector) {
            let price = '';
            let oldPrice = '';
            let save_money = '';
            let save_percent = '';

            product.prices.forEach((item) => {
                if (item.id === variantId) {
                price = item.price;
                }
                return
            });

            product.compare_prices.forEach((item) => {
                if (item.id === variantId) {
                    oldPrice = item.compare_price;
                    save_money = oldPrice.replace(/[^.0-9]/gim,'') - price.replace(/[^.0-9]/gim,'');
                    save_percent = 100 - ((price.replace(/[^.0-9]/gim,'')*100 / oldPrice.replace(/[^.0-9]/gim,'')));
                    save_percent = save_percent.toFixed(2);
                }
                return
            });

            selector.find('.product-regular-price').html(price);
            if(oldPrice != ''){
                selector.find('.save_money_block').css('display','inline-block');
                selector.find('.old-price').css('display','inline-block');
                selector.find('.old-price').html(oldPrice);
                selector.find('.save_money').html(save_money.toFixed(2));
                selector.find('.save_percent').html('(' + save_percent + '%)');
            }
            else{
                selector.find('.old-price').css('display','none');
                selector.find('.save_money_block').css('display','none');
            }
            update_currencies();
        },

        updateShortInfo: function (variant, variantCount, selector) {
            let infoList = $('.short-product-info');

          
            infoList.removeClass('untrack_quantity');
			infoList.add(".count-product-progress_wrapp").removeClass('null_quantity');
            if( !variant.inventory_management){
				infoList.addClass('untrack_quantity');
			}
			if( !variant.available){
				infoList.add(".count-product-progress_wrapp").addClass('null_quantity');
			}

            if (infoList.length > 0) {

                if (variant) {
                    $(".js-option.active").each(function () {
                        $(this).removeClass('disable');
                    });
                    infoList.find('.btn-add-to-cart').removeAttr('disabled');
                    $('.shopify-payment-button__button').removeAttr('disabled');
                    if (variant.sku) {
                        selector.find('.product-sku').text(variant.sku);
                    }

                    if (variant.barcode) {
                        selector.find('.product-barcode').text(variant.barcode);
                    }
                    selector.find('.product-count').text(variantCount);
                } else {
                    $(".js-option.active").each(function () {
                        $(this).addClass('disable');
                    });
                    $('.shopify-payment-button__button').attr('disabled', 'true');
                    infoList.find('.btn-add-to-cart').attr('disabled', 'true');
                    infoList.find('.product-count').text('0');
                }
            }
        },

        updateAddButton: function (variantCount, selector) {
            let soldOutText = selector.find('.btn-add-to-cart').attr('data-soldout');
            let addToCartText = selector.find('.btn-add-to-cart').attr('data-addtocart');
            if ( variantCount == 0 && selector.find('.product-single__variants option[selected="selected"]').attr('disabled') == 'disabled' ) {
                selector.find('.shopify-payment-button__button').prop('disabled', true);
                selector.find('.btn-add-to-cart').prop('disabled', true);
                selector.find('.btn-add-to-cart span').text(soldOutText);
                selector.find('.product-flag.sold-out').show();
            }
            else{
                selector.find('.shopify-payment-button__button').prop('disabled', false);
                selector.find('.btn-add-to-cart').prop('disabled', false);
                selector.find('.btn-add-to-cart span').text(addToCartText);
                selector.find('.product-flag.sold-out').hide();
            }
        },

        updatePhotoProduct: function (variant) {
            if (variant.featured_image) {
                let idImage = variant.featured_image.id;
                let photoSliderItem = $(`.product-photos-list-item[data-image-id="${idImage}"]`);

                if (photoSliderItem.length > 0) {
                    $('.product-photos-list-item').removeClass('active');
                    photoSliderItem.addClass('active');
                }

                // code switch image for slider (3 img )
                if ($('.product_slider_three_img').hasClass('owl-loaded')) {
                    let pos = $(`.product-image-item[data-image-id="${idImage}"]`).data('position');
                    if ($(window).outerWidth() > 481) {
                        pos = pos - 1;
                    }

                    $('.product-image-item').closest('.owl-item').removeClass('active');

                    setTimeout(function () {
                        $('.product_slider_three_img').trigger('to.owl.carousel', [pos, 300]);
                    }, 100);
                } else {}
                // code switch image for grid & slider

                if ($('.product_layout_slider').hasClass('owl-loaded')) {
                    let pos = $(`.product-image-item[data-image-id="${idImage}"]`).data('position');
                    $('.product-photos-list-item').removeClass('active');
                    $('.product-image-item').closest('.owl-item').removeClass('active');
                    $(`.product-photos-list-item[data-image-id="${idImage}"]`).addClass('active');

                    setTimeout(function () {
                        $('.product_layout_slider').trigger('to.owl.carousel', [pos, 300]);
                    }, 100);
                } else {}

                // code switch image for horizontal slider
                if ($('.product-photos-list').hasClass('owl-carousel')) {
                    let pos = photoSliderItem.find('.product-single__thumbnail').data('position');

                    photoSliderItem.find('.product-single__thumbnail img').click();
                    setTimeout(function () {
                        photoSliderItem.closest('.product-photos-list').trigger('to.owl.carousel', [pos, 300]);
                    }, 100);

                } else {
                    photoSliderItem.find('.product-single__thumbnail img').click();
                }


                // code switch image for vertical slider
                if ($(".product-photos-list").hasClass('vcarousel')) {
                    let slickItem = photoSliderItem.not('.slick-cloned');
                    let slickSlideIndex = slickItem.data('slick-index');
                    slickItem.addClass('active');
                    if($(".product-photos-list").find('.slick-arrow').length != 0){
                        setTimeout(function () {
                            $(".product-photos-list").slick('slickGoTo', (slickSlideIndex));
                        }, 300);
                    }
                    slickItem.find('.product-single__thumbnail img').click();
                }

                // code switch image for without slider
                if ($('.product-image_without_slider').length > 0) {
                    let photoWithoutSlider = $(`.product-image_without_slider[data-image-id="${idImage}"]`);
                    let posPhoto = photoWithoutSlider.position().top;
                    let heightImage = photoWithoutSlider.height();
                    let heightWindow = $(window).height();
                    let diff = (heightWindow - heightImage) / 2;

                    $('.product-image_without_slider').removeClass('active');
                    photoWithoutSlider.addClass('active');

                    setTimeout(function () {

                        if (posPhoto > 0) {
                            $('html').stop().animate({
                                scrollTop: posPhoto + diff
                            }, 1500);
                        } else {
                            $('html').stop().animate({
                                scrollTop: posPhoto
                            }, 1500);
                        }

                    }, 300);

                    $(document).trigger('scroll');
                }
            }
        },

        updatePhotoMiniature: function (variant, selector) {
            let hoverEffect = selector.data('hover-effect');

            if (variant.featured_image) {
                let idImage = variant.featured_image.id;
                switch (hoverEffect) {

                    case 'fade':
                        if(selector.find('.hover_change').length !=0 ){
                            selector.find('.hover_change').removeClass('cover');
                            selector.find(`[data-image-id="${idImage}"]`).addClass('cover');
                        }
                        break;

                    case 'classic':
                        selector.find('.thumbnail-container-image img').attr('src', variant.featured_image.src);
                        selector.find('.thumbnail-container-image img').data('src', variant.featured_image.src);

                        break;

                    case 'slider':
                        let photoSliderItem = selector.find(`.hover-slider-item[data-image-id="${idImage}"]`);
                        let pos = photoSliderItem.data('position');
                        photoSliderItem.closest('.hover-slider').trigger('to.owl.carousel', [pos, 300]);

                        break;
                }


                if (selector.length > 0) {
                    let photoSliderItem = selector.find(`.qw-product-images-item[data-image-id="${idImage}"]`);
                    let pos = photoSliderItem.data('position');

                    setTimeout(function () {
                        photoSliderItem.closest('.qw-product-images').trigger('to.owl.carousel', [pos, 300]);
                    }, 100);
                }

            }
        },

        updateOptions: function (product, defaultVariantId, selector, callback) {
            let variants = {};
            let variantsSelected = {};
            let defaultOption;
            let selectedVariantsId = null;
            let url = window.location.href;
            product.variants.forEach((variant) => {
               if (variant.id === +defaultVariantId) {
                    variant.options.forEach((option, index) => {
                        variants[product.options[index]] = '' + option;
                        if(option.indexOf('_double_quote') != -1){
                            selector.find(`.js-option[data-value=\'${option.replace('_double_quote','"')}\']`).addClass('active');
                        }
                        else if(option.indexOf('_single_quote_') != -1 ){
                            selector.find(`.js-option[data-value=\"${option.replace('_single_quote_',"'")}\"]`).addClass('active');
                        }
                        else{
                            selector.find(`.js-option[data-value=\"${option}\"]`).addClass('active');
                        }
                    });
                }
                return
            });

            const url_product = window.location.href.replace(window.location.search, '');
            selector.find(`.product-single__variants option[value="${defaultVariantId}"]`).attr('selected', true);

            defaultOption = selector.find(`.product-options_all .js-option[data-optionid="${defaultVariantId}"]`).addClass('active').html();

            selector.find('.all_in_one_select .selected_item').html(defaultOption);

            selector.find('.product-options .js-option').on('click', (e) => {


                let clicked = $(e.target).closest('.js-option').attr('data-value_down');
                let clickedelem = selector.find(`.product-options .js-option[data-value_down="${clicked}"]`);
                clickedelem.nextAll('.js-option').removeClass('active');
                clickedelem.prevAll('.js-option').removeClass('active');
                clickedelem.addClass('active');




                let elem;
                if ($(e.target).closest('select').length > 0) {
                    elem = $(e.target).find('option:selected');
                } else {
                    elem = $(e.target).closest('.js-option');
                }
                let value = elem.closest('.product-options').attr('data-section-name');

                url = '';
                if (value) {
                    variants[value] = elem.data('value').toString().replace("'","_single_quote_").replace('"','_double_quote');
                }

                elem.nextAll('.js-option').removeClass('active');
                elem.prevAll('.js-option').removeClass('active');
                elem.addClass('active');
                selector.find('.product-single__variants option').each(function () {
                    let titles;
                    if(product.options.length > 1){
                        titles = $(this).data('title').split(' / ');
                        for (let i = 0; i < titles.length; i++) {
                            variantsSelected[product.options[i]] = titles[i].replace("'","_single_quote_").replace('"','_double_quote') + '';
                        }
                    }
                    else{
                        titles = $(this).data('title')+ '';
                        variantsSelected[product.options[0]] = titles.replace("'","_single_quote_").replace('"','_double_quote') + '';
                    }

                    if (JSON.stringify(variants).toLowerCase() === JSON.stringify(variantsSelected).toLowerCase()) {
                        selector.find('.product-single__variants option').removeAttr('selected');
                        $(this).attr('selected', 'true');
                        selectedVariantsId = $(this).attr('value');

                        return false;
                    } else {
                        selectedVariantsId = null;
                        $(this).removeAttr('selected');
                    }
                });
                selector.find('.product-single__variants_footer option').each(function () {
                    let titles;
                    if(product.options.length > 1){
                        titles = $(this).data('title').split(' / ');
                        for (let i = 0; i < titles.length; i++) {
                            variantsSelected[product.options[i]] = titles[i].replace("'","_single_quote_").replace('"','_double_quote') + '';
                        }
                    }
                    else{
                        titles = $(this).data('title')+ '';
                        variantsSelected[product.options[0]] = titles.replace("'","_single_quote_").replace('"','_double_quote') + '';
                    }

                    if (JSON.stringify(variants) === JSON.stringify(variantsSelected)) {
                        selector.find('.product-single__variants_footer option').removeAttr('selected');
                        $(this).attr('selected', 'true');
                        selectedVariantsId = $(this).attr('value');

                        return false;
                    } else {
                        selectedVariantsId = null;
                        $(this).removeAttr('selected');
                    }
                });
                update_currencies();

                if (selectedVariantsId) {
                    callback(product, selectedVariantsId, selector);
                    if ($('body').hasClass('template-product') && $(e.target).closest('.product-single').length > 0) {
                        url = url_product + `?variant=${selectedVariantsId}`; +
                            history.pushState({}, null, url);
                    }

                } else {
                    Product.updateShortInfo(null, 0);
                    Product.updateProgressBar(null, 0);
                    Product.updateAddButton(0, selector);
                }
            });

            // handle for select option
            selector.find('select.product-options').on('change', (e) => {
                let elem = $(e.target);
                let value = elem.data('section-name');
                let clicked = $(e.target).find(':selected').attr('data-value_down');
                selector.find(`select.product-options[data-section-name="${value}"] [data-value_down="${clicked}"]`).attr('selected', 'true');
                url = '';
                if (value) {
                    variants[value] = elem.val().toString().replace("'","_single_quote_").replace('"','_double_quote');
                }

                selector.find('.product-single__variants option').each(function () {
                    let titles;
                    let selected;
                    if(product.options.length > 1){
                        titles = $(this).data('title').split(' / ');
                        for (let i = 0; i < titles.length; i++) {
                            variantsSelected[product.options[i]] = titles[i].replace("'","_single_quote_").replace('"','_double_quote') + '';
                        }
                    }
                    else{
                        titles = $(this).data('title')+ '';
                        variantsSelected[product.options[0]] = titles.replace("'","_single_quote_").replace('"','_double_quote') + '';
                    }
                    if (JSON.stringify(variants) === JSON.stringify(variantsSelected)) {
                        selector.find('.product-single__variants option').removeAttr('selected');
                        $(this).attr('selected', 'true');

                        selected = $(this).attr('data-sku');
                        selector.find('.product-single__variants_footer option').removeAttr('selected');
                        selector.find(`.product-single__variants_footer option[data-sku="${selected}"]`).attr('selected', 'true');

                        selectedVariantsId = $(this).attr('value');

                        return false;
                    } else {
                        selectedVariantsId = null;
                        $(this).removeAttr('selected');
                    }
                });

                update_currencies();

                if (selectedVariantsId) {
                    callback(product, selectedVariantsId, selector);
                    if ($('body').hasClass('template-product') && $(e.target).closest('.product-single').length > 0) {
                        url = url_product + `?variant=${selectedVariantsId}`; +
                            history.pushState({}, null, url);
                    }

                } else {
                    Product.updateShortInfo(null, 0);
                    Product.updateProgressBar(null, 0);
                    Product.updateAddButton(0, selector);
                }
            });





              // handle for all_in_one option
            selector.find('.all_in_one_select .js-option').on('click', (e) => {
                let elem = $(e.target);

                if(!elem.hasClass('js-option')){
                    elem = elem.closest('.js-option');
                }
                elem.nextAll('.js-option').removeClass('active');
                elem.prevAll('.js-option').removeClass('active');
                elem.addClass('active');
                let value = elem.attr('data-value');
                let selected = elem.attr('data-value');
                url = '';
                selector.find('.product-single__variants option').each(function () {
                    let title = $(this).data('title');
                    let selected_elem;
                    if (JSON.stringify(title).toLowerCase() === JSON.stringify(value).toLowerCase()) {
                        selector.find('.product-single__variants option').removeAttr('selected');
                        $(this).attr('selected', 'true');

                        selected_elem = $(this).attr('value');
                        selector.find('.product-single__variants_footer option').removeAttr('selected');
                        selector.find(`.product-single__variants_footer option[value="${selected_elem}"]`).attr('selected', 'true');




                        selectedVariantsId = $(this).attr('value');
                        selected = selector.find(`.product-options_all .js-option[data-optionid="${selectedVariantsId}"]`).html();
                        selector.find('.all_in_one_select .selected_item').html(selected);
                        return false;
                    } else {
                        selectedVariantsId = null;
                        $(this).removeAttr('selected');
                    }
                });

                update_currencies();

                if (selectedVariantsId) {
                    callback(product, selectedVariantsId, selector);
                    if ($('body').hasClass('template-product') && $(e.target).closest('.product-single').length > 0) {
                        url = url_product + `?variant=${selectedVariantsId}`; +
                            history.pushState({}, null, url);
                    }
                }
            });
        }
    }
})();